export const requisicoes = (state) => {
  return state.requisicoes.data || []
}

export const requisicoesLoading = (state) => {
  return state.requisicoes.loading
}

export const requisicoesLastUpdate = (state) => {
  return state.requisicoes.lastUpdate
}

export const activePolling = (state) => {
  return state.activePolling || {}
}
